import {SplashScreen} from '@capacitor/splash-screen';

export const useHideSplashScreen = () => {
  setTimeout(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    SplashScreen.hide();
  }, 500);
};
